import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">10,000 Processors at a Moment’s Notice</h3>
      <p className="chapter__paragraph">
        The next step was to build a tech stack that could handle enormous video files remotely and
        be available to its team anywhere in the world. Company 3 kept its data centers, comprised
        of some 100,000 processors, and connected them through the new global network in the AWS
        cloud. Now, team members in London, New York, LA, and Sydney could all work together,
        sharing the same media and storing and processing that media in the cloud.
      </p>
      <p className="chapter__paragraph">
        Last but not least, the Company 3 engineering team assessed scalability. Company 3 needed to
        be able to flex its project capacity to meet its needs at any given time but didn’t want to
        pay for excess capacity during a slow cycle. In the cloud, production teams could tap
        Company 3 servers from around the world and add tens to hundreds of thousands of additional
        CPUs to any processing task as needed. Adding a new remote postproduction studio became
        almost as easy as flipping a switch.
      </p>
    </section>
  );
}

export default Chapter4;
